import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { BaseCustomProps } from './types';

export const Alert: React.FC<BaseCustomProps> = ({ 
  children, 
  className,
  type = 'default'
}) => (
  <>
    {/* Add a line break before and after for block-level spacing */}
    <span 
      className={twMerge(
        "block rounded-lg", // Make it block-level with rounded corners
        type === 'error' ? "bg-[hsl(0,80%,95%)] border-l-4 border-[var(--destructive)] text-[hsl(0,70%,40%)]" :
        type === 'warning' ? "bg-[hsl(20,80%,95%)] border-l-4 border-[var(--coral)] text-[hsl(20,80%,35%)]" :
        type === 'success' ? "bg-[hsl(150,40%,95%)] border-l-4 border-[var(--moss)] text-[hsl(150,40%,30%)]" :
        "bg-[hsl(200,65%,95%)] border-l-4 border-[var(--teal)] text-[hsl(200,65%,30%)]",
        "px-4 py-3 my-4",
        className
      )}
    >
      {children}
    </span>
  </>
);

export default Alert;